import { createSlice } from '@reduxjs/toolkit'

import { reducerRegistry } from 'reducer-registry'

const initialState = {
  /** Event-type editor booking preview overlay is open (not other ET side panels). */
  isBookingPreviewOpen: false,
}

const slice = createSlice({
  name: 'shellLayout',
  initialState,
  reducers: {
    setBookingPreviewOpen: (state, { payload }) => {
      state.isBookingPreviewOpen = payload
    },
  },
})

reducerRegistry.add('shellLayout', slice.reducer)

export const { setBookingPreviewOpen } = slice.actions
